let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ainDE")).then(() => parcelRequire('hbdA6'));